<template>
  <div class="big_data">
    <Header></Header>
    <Banners :banner="banner"></Banners>

    <div class="part1">
      <p class="title">大数据平台建设情况</p>
      <ul class="model">
        <li v-for="item in part1">
          <img :src="item.imgUrl" />
        </li>
      </ul>
      <div class="clear"></div>
      <p class="remark">苏州瑞鹏信息技术有限公司已经构建符合自己特色的用户标签体系，建立<span>17+</span> 维表；11大类超过<span>106</span>个标签与模型，拥有并基于spark大数据生态组建作为核心处理技术，对海量数据进行规整处理，刻画出用户画像体系，并不断迭代、丰富受众标签描述。在此基础上利用业务的正、负样本数据，使用TGI(Target Group Index)对受众行为偏好进行计算，找寻出最优质最符合条件的受众，为运营提供精准营销服务，实现千人千面的营销策略。</p>
    </div>

    <div class="part4">
      <p class="title">产投研合作单位</p>
      <ul class="items">
        <li v-for="item in part3">
          <img :src="item.imgUrl" />
          <p class="name">{{item.name}}</p>
          <p class="remark">{{item.remark}}</p>
        </li>
      </ul>
      <div class="clear"></div>
      <p class="text">聚集产业链上、中、下游各端企事业单位，</p>
      <p class="text">充分发挥产、学、研、政、中、金、用等各方优势</p>
      <p class="text">带动相关地区金融大数据应用领域的持续发展</p>

      <p class="sub_title">银行</p>
      <ul class="products">
        <li v-for="item,index in part2" v-if="index<=15">
          <img :src="item.imgUrl" />
        </li>
      </ul>
      <div class="clear"></div>
      <p class="sub_title">金融机构</p>
      <ul class="products">
        <li v-for="item,index in part2" v-if="index>=16 && index <= 23">
          <img :src="item.imgUrl" />
        </li>
      </ul>
      <p class="sub_title">保险</p>
      <ul class="products">
        <li v-for="item,index in part2" v-if="index>=25 && index <= 33">
          <img :src="item.imgUrl" />
        </li>
      </ul>
      <div class="clear"></div>
      <p class="sub_title">科研机构</p>

      <ul class="products">
        <li v-for="item,index in part2"  v-if="index==24">
          <img :src="item.imgUrl" />
        </li>
      </ul>
      <div class="clear"></div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
  import Header from "@/mComponents/Header"
  import Banners from "@/mComponents/Banners"
  import Footer from "@/mComponents/Footer"

  export default {
    name: 'Big_Data',
    data() {
      return {
        banner: require("@/assets/imgs/mobile/banner-03.png"),
        img3: require("@/assets/imgs/mobile/img-cup.png"),
        part1: [
          {imgUrl:require("@/assets/imgs/mobile/ic-17.png")},
          {imgUrl:require("@/assets/imgs/mobile/ic-106.png")},
        ],
        part2:[
          {imgUrl:require("@/assets/imgs/mobile/01.png")},
          {imgUrl:require("@/assets/imgs/mobile/02.png")},
          {imgUrl:require("@/assets/imgs/mobile/03.png")},
          {imgUrl:require("@/assets/imgs/mobile/04.png")},
          {imgUrl:require("@/assets/imgs/mobile/05.png")},
          {imgUrl:require("@/assets/imgs/mobile/06.png")},
          {imgUrl:require("@/assets/imgs/mobile/07.png")},
          {imgUrl:require("@/assets/imgs/mobile/08.png")},
          {imgUrl:require("@/assets/imgs/mobile/09.png")},
          {imgUrl:require("@/assets/imgs/mobile/10.png")},
          {imgUrl:require("@/assets/imgs/mobile/11.png")},
          {imgUrl:require("@/assets/imgs/mobile/12.png")},
          {imgUrl:require("@/assets/imgs/mobile/13.png")},
          {imgUrl:require("@/assets/imgs/mobile/14.png")},
          {imgUrl:require("@/assets/imgs/mobile/15.png")},
          {imgUrl:require("@/assets/imgs/mobile/16.png")},
          {imgUrl:require("@/assets/imgs/mobile/17.png")},
          {imgUrl:require("@/assets/imgs/mobile/18.png")},
          {imgUrl:require("@/assets/imgs/mobile/19.png")},
          {imgUrl:require("@/assets/imgs/mobile/20.png")},
          {imgUrl:require("@/assets/imgs/mobile/21.png")},
          {imgUrl:require("@/assets/imgs/mobile/22.png")},
          {imgUrl:require("@/assets/imgs/mobile/23.png")},
          {imgUrl:require("@/assets/imgs/mobile/24.png")},
          {imgUrl:require("@/assets/imgs/mobile/25.png")},
          {imgUrl:require("@/assets/imgs/mobile/26.png")},
          {imgUrl:require("@/assets/imgs/mobile/27.png")},
          {imgUrl:require("@/assets/imgs/mobile/28.png")},
          {imgUrl:require("@/assets/imgs/mobile/29.png")},
          {imgUrl:require("@/assets/imgs/mobile/30.png")},
          {imgUrl:require("@/assets/imgs/mobile/31.png")},
          {imgUrl:require("@/assets/imgs/mobile/32.png")},
          {imgUrl:require("@/assets/imgs/mobile/33.png")},
          {imgUrl:require("@/assets/imgs/mobile/34.png")},
          ],
        part3: [
          {imgUrl: require("@/assets/imgs/mobile/ic-data-cooperation-01.png"),name:"16+",remark:"银行"},
          {imgUrl: require("@/assets/imgs/mobile/ic-data-cooperation-02.png"),name:"8+",remark:"金融机构"},
          {imgUrl: require("@/assets/imgs/mobile/ic-data-cooperation-03.png"),name:"1+",remark:"科研机构"},
        ]
      }
    },
    components: {
      Header,Banners,Footer,
    },
    created() {
      window.scrollTo(0,0);
      this.$store.commit('changeNavsM', 'mBig_Data')
    },
    methods: {
      noClick() {
        return false;
      }
    },
    mounted() {
      $('.part1 ul li').addClass("active");
      var screenHeight =  document.documentElement.clientHeight
      setTimeout(function() {
        window.onscroll = function() {
          var bool = $(window).scrollTop()+$(window).height()==$(document).height();
          var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let fontSize = getComputedStyle(window.document.documentElement)['font-size'];
          if(scrollTop>30) {
            $(".icon-m-up").css("display","block")
            $(".top").addClass("active")
          } else {
            $(".icon-m-up").css("display","none")
            $(".top").removeClass("active")
          }
          var lis = $('.part4 ul li')
          for(var i =0;i<lis.length;i++) {
            var offsetTop = $(lis[i]).offset().top
            if(offsetTop - scrollTop - screenHeight < 0 && !bool && !$(lis[i]).hasClass('active')) {
              $(lis[i]).addClass('active')
            }
          }
        }
      },100)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped lang="scss" type="text/scss">
  @import '../../assets/css/animation.css';
  .big_data {
    background-color: #fff;

    .clear {
      clear: both;
    }
    .part1 {
      padding: 0.7rem 0 0.5rem;
      .title {
        font-size:0.48rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        text-align: center;
        margin-bottom: 0.7rem;
      }
      ul {
        margin: 0 0.7rem;
        display: inline-block;
        li {
          float: left;
          margin: 0 0.55rem;
          width: 1.86rem;
          height: 1.86rem;
          &.active img{
             -moz-animation: RotateY 0.3s linear forwards;
             -ms-animation: RotateY 0.3s linear forwards;
             -webkit-animation: RotateY 0.3s linear forwards;
             -o-animation: RotateY 0.3s linear forwards;
             animation: RotateY 0.3s linear forwards;
           }
          img {
            opacity: 0;
            width: 1.86rem;
            height: 1.86rem;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
        }
      }
      .remark {
        font-size:0.24rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:0.4rem;
        margin: 0.3rem 0.4rem 0;
        span {
          display: inline-block;
          font-size: 0.6rem;
          line-height: 0.8rem;
          font-weight: 500;
          font-weight: 500;
          margin: 0 0.1rem;
        }
        span:nth-child(1) {
          color: #4196ff;
        }
        span:nth-child(2) {
          color: #FB6604;
        }
      }
    }

    .part4 {
      padding: 0.7rem 0;
      background:rgba(237,237,237,1);
      p {
        text-align: center;
      }
      .title {
        font-size:0.48rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
      }
      .text {
        font-size:0.24rem;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:0.48rem;
        opacity:0.6;
      }
      .sub_title {
        font-size:0.28rem;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:0.6rem;
        margin-top: 0.3rem;
      }
      ul.items {
        margin: 0.5rem 0;
        display: flex;
        li {
          float: left;
          width: 33.33%;
          &.active img{
             -moz-animation: RotateY 0.3s linear forwards;
             -ms-animation: RotateY 0.3s linear forwards;
             -webkit-animation: RotateY 0.3s linear forwards;
             -o-animation: RotateY 0.3s linear forwards;
             animation: RotateY 0.3s linear forwards;
           }
          img {
            display: block;
            width: 1.6rem;
            height: 1.6rem;
            margin: 0 auto;
            transform:RotateY(30deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
          .name {
            font-size:0.6rem;
            font-family:PingFangSC-Bold;
            font-weight:bold;
            color:rgba(0,0,0,1);
            line-height:0.8rem;
          }
          .remark {
            font-size:0.28rem;
            font-family:PingFangSC-Medium;
            font-weight:500;
            color:rgba(0,0,0,1);
            line-height:0.4rem;
            opacity:0.8;
          }
        }
      }
      ul.products {
        margin: 0 0.65rem;
        display: inline-block;
        li {
          float: left;
          width: 2.8rem;
          height: 0.8rem;
          height: 0.8rem;
          margin: 0.3rem 0.15rem 0;
          &.active img{
             -moz-animation: RotateY 0.3s linear forwards;
             -ms-animation: RotateY 0.3s linear forwards;
             -webkit-animation: RotateY 0.3s linear forwards;
             -o-animation: RotateY 0.3s linear forwards;
             animation: RotateY 0.3s linear forwards;
           }
          img {
            opacity: 0;
            width: 2.8rem;
            display: inline-block;
            vertical-align: top;
            transform:RotateY(90deg);
            -ms-transform:RotateY(90deg); 	/* IE 9 */
            -moz-transform:RotateY(90deg); 	/* Firefox */
            -webkit-transform:RotateY(90deg); /* Safari 和 Chrome */
            -o-transform:RotateY(90deg); 	/* Opera */
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Mobile/Big_Data.vue